/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import { omit } from 'lodash';

type FieldList = Record<string, any>;

const sanitizeFieldList = (
  fieldList: FieldList,
  toRemoveFields: any,
  pruneTopLevelKeys: any,
): FieldList => {
// start with a shallow clone
  const pruned: FieldList = { ...fieldList };

  // 1) remove specified sub-fields
  for (const prefix in toRemoveFields) {
    const keys = toRemoveFields[prefix];
    const group = pruned[prefix];
    if (group && Array.isArray(keys)) {
      pruned[prefix] = omit(group, ...keys);
    }
  }

  // 2) remove any now-empty prefix objects
  for (const prefix in pruned) {
    if (
      pruned[prefix]
      && typeof pruned[prefix] === 'object'
      && !Array.isArray(pruned[prefix])
      && Object.keys(pruned[prefix]).length === 0
    ) {
      delete pruned[prefix];
    }
  }

  // 3) prune specified top-level keys
  for (const key of pruneTopLevelKeys) {
    if (pruned[key] !== undefined) {
      delete pruned[key];
    }
  }

  return pruned;
};

export default sanitizeFieldList;
